import { render, staticRenderFns } from "./FormOutputLabel.vue?vue&type=template&id=5102681e&"
import script from "./FormOutputLabel.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FormOutputLabel.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports